export class Section {
    constructor({ renderer }, selector) {
        this._renderer = renderer;
        this._container = document.querySelector(selector);
    }

    renderItems(data) {
        data.forEach(this._renderer); // Actually function has assigned to every single item in array: forEach(item => this._renderer(item)); 
    }

    addItem(itemHtml) {
        this._container.prepend(itemHtml);
    }
}